// extracted by mini-css-extract-plugin
export var cardContainer = "styles-module--cardContainer--6372e";
export var popularPostsContainer = "styles-module--popularPostsContainer--ac6b4";
export var postGrid = "styles-module--postGrid--eab71";
export var title = "styles-module--title--468e4";